import axios from "axios";

//创建axios的实例
const httpService = axios.create({
  baseURL: process.env.VUE_APP_open_API_URL, // TODO:具体的配置可以根据项目情况而来
  timeout: 50000,
});
// 物流信息查询
export function getTrackingInfo(params) {
  return httpService({
    url: `/waybill/search`,
    method: "post",
    data: params,
  });
}
